class MenuDesktop {
  // 1. describe and create/initiate object
  constructor() {
    this.header = document.querySelector(".site-header")
    this.events()
    this.checkScrollPosition() // Check position on initialization
  }

  // 2. events
  events() {
    window.addEventListener("scroll", () => this.checkScrollPosition())
  }

  // 3. methods
  checkScrollPosition() {
    if (window.scrollY > 0) {
      this.header.classList.add("scrolled")
      this.header.classList.remove("at-top")
         
    } else {
      this.header.classList.add("at-top")
      this.header.classList.remove("scrolled")
        
    }
  }
}

export default MenuDesktop
